<template>
  <div>
    <carihareketbaseaktarim
    
     
      v-model="items"
      v-on:submitfile="SubmitFile"
      :status="status"
      :menuitems="menuItems"
      v-on:menuclick="menuClick"
     
    ></carihareketbaseaktarim>
  </div>
</template>
  
  <script>
import carihareketbaseaktarim from "@/components/app/cariaktarim/carihareketbaseaktarim.vue";
import tool from "@/components/app/coper/tools";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
   
  data() {
    return {
       
      items: [],
      status: tool.NewSatatus(),
      menuItems: [
        {
          title: this.$t('Download-Sample-File'),
        },
      ],
    };
  },

  components: {
    carihareketbaseaktarim,
  },
 
  methods: {
    menuClick(index) {
      if (index == 0) {
        this.DownloadFile("CariKartAktarimi.xlsx");
      } else if (index == 1) {
      }
    },

    DownloadFile(file) {
      var prm = {
        FileName: file,
      };

      this.status.loading = true;
      setTimeout(() => {
        tool.api_post_FileDownload(this, "CariStream/DownloadFile", prm).then(
          (response) => {
            tool.CreateDownloadLink(response, file);
            this.status.loading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
          }
        );
      }, 5000);
    },

    SubmitFile(files) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append("files[" + i + "]", file);
      }

      this.status.loading = true;
      tool.api_file_post(this, "CariStream/ExcelCariKartKaydet", formData).then(
        (response) => {
          this.items = response.body;
          this.status.loading = false;
        },
        (response) => {
          this.status = tool.responseToStatus(response);
        }
      );
    },
  },
};
</script>
  